import React, { useState } from 'react'
import { Action, FilterType, TreeFilterType } from './types'
import { Box } from '@mui/material'
import { TreeFilter } from './TreeFilter'
import { FilteredTreeTable } from './FilteredTreeTable'
import { Actions } from './treeActions/Actions'
import BasicTabs, { BasicTabType } from '../../utility/Tabs'
import { AllPreDefinedFilters } from './preDefinedFilters/AllPredefinedFilters'

export function TreeManipulation({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const tabs: BasicTabType[] = [
    [
      'Pre Defined',
      () => <AllPreDefinedFilters treeId={treeId} versionId={versionId} />,
    ],
    [
      'Free Form',
      () => <FreeFormFilters treeId={treeId} versionId={versionId} />,
    ],
  ]
  return (
    <Box>
      <BasicTabs tabComponents={tabs} />
    </Box>
  )
}

function FreeFormFilters({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const [filter, setFilter] = useState<TreeFilterType>({
    filterType: FilterType.node,
  })
  const [action, setAction] = useState<Action>()

  const onFilterChange = (f: TreeFilterType) => {
    if (f.filterType !== filter.filterType) {
      setAction(undefined)
    }
    setFilter(f)
  }

  return (
    <Box>
      <Box>Tree Manipulation</Box>
      <TreeFilter filter={filter} onFilterChange={onFilterChange} />
      <Box>
        <Actions
          action={action}
          onActionChange={setAction}
          filterType={filter.filterType}
        />
      </Box>
      {filter && (
        <FilteredTreeTable
          filter={filter}
          treeId={treeId}
          versionId={versionId}
          action={action}
        />
      )}
    </Box>
  )
}
